import axios from "axios"
import { API_BASE_URL } from "@/config/config";

export const urlBase = API_BASE_URL;


const App = () => {
    let token = localStorage.getItem("token");

    const api = axios.create({
        baseURL: urlBase,
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer '+token
        },
        timeout: 30000
    });

    // error
    api.interceptors.response.use(
        (response) => {
            return response;
        },
        (error) => {
            if(error.response && error.response.status === 401){
                localStorage.removeItem("token")
                localStorage.removeItem("permisos")
                localStorage.removeItem("userData")
                window.location.href = "/login"
            }
            if(error.response && error.response.status === 403){
                window.location.href = "/no-autorizado"
            }

            return Promise.reject(error)
        }
    )
    return api;
}

export default App;
